'use client'

import { useState } from 'react'

interface FoodImageProps {
  src: string
  alt: string
  emoji: string
  className?: string
}

// Image appétissante avec repli élégant (dégradé + emoji) si la photo ne charge pas.
export function FoodImage({ src, alt, emoji, className = '' }: FoodImageProps): React.ReactElement {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-brand-orange via-brand-red to-brand-red-dark ${className}`}
        role="img"
        aria-label={alt}
      >
        <span className="text-6xl drop-shadow-lg" aria-hidden>
          {emoji}
        </span>
      </div>
    )
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`object-cover ${className}`}
    />
  )
}
